import * as Sentry from '@sentry/react';
import { NativeEventBus } from '../native/NativeEventBus';
import { TrackingEvent, PlayEvent } from './types';
import { Game } from '../components/Games/games.model';

export const trackEvent = <T extends TrackingEvent>(eventData: T): void => {
  if (NativeEventBus.isNativeBridgeAvailable()) {
    new NativeEventBus().trackEvent(eventData);
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
  }

  if (Sentry.isInitialized()) {
    Sentry.addBreadcrumb({
      category: 'gtm',
      message: eventData.event,
      data: eventData,
      level: 'info',
    });
  }
};

export const trackPlayEvent = (game: Game): void => {
  const playEvent: PlayEvent = {
    event: 'play',
    properties: {
      name: game.displayName,
      game_id: game.gameId,
      category: game.categoryName || '',
      subcategory: game.category?.slug || game.category?.title || '',
      features: game.features?.map((f) => f.displayName) || [],
      spec: {
        'Min Bet': game.minBet || '',
        currency: 'GBP',
        Paylines: game.paylines || '',
        RTP: game.rtp ? `${game.rtp}%` : '',
      },
    },
  };

  trackEvent(playEvent);
};
